import { TierChangePolicy } from "@mimber/schema"

export const TIER_CHANGE_POLICY_LABELS: Record<TierChangePolicy, string> = {
  [TierChangePolicy.NEXT_CYCLE]: "Next Cycle",
  [TierChangePolicy.PRORATE]: "Prorate",
  [TierChangePolicy.IMMEDIATE]: "Void & Restart Immediately",
}

export const TIER_CHANGE_POLICY_OVERRIDE_OPTIONS = (
  Object.entries(TIER_CHANGE_POLICY_LABELS) as [TierChangePolicy, string][]
).map(([value, label]) => ({ label, value }))
